import React from 'react';
import './AppointmentNavigator.css';
import { Route, Redirect, RouteComponentProps } from 'react-router-dom';
import UploadPrescription from '../pages/appointmentSteps/UploadPrescription';
import SetPatient from '../pages/appointmentSteps/SetPatient';
import { IonRouterOutlet } from '@ionic/react';
import Summary from '../pages/appointmentSteps/Summary';
import ThankYou from '../pages/appointmentSteps/ThankYou';
import RegisterStep from '../pages/appointmentSteps/RegisterStep';
import { AuthenticationRootState } from '../store/reducers/authentication';
import { connect } from 'react-redux';
import TabBar from '../components/TabBar';
import { COVID_REGISTRATION_ROUTE } from './AppStackNavigator';
import CovidRegistrationStepper from '../components/CovidRegistrationStepper';

const mapStateToProps = (
  state: { authentication: AuthenticationRootState },
  ownProps: any
) => {
  return {
    user: state.authentication.user,
    isLoggedIn: !!state.authentication.accessToken
  };
};

export type CovidRegistrationNavigatorProps = ReturnType<
  typeof mapStateToProps
> &
  RouteComponentProps & {
    isCovid: boolean;
    isSidepOnly: boolean;
    skipSlot: boolean;
    automaticCheckin: boolean;
  };

const CovidRegistrationNavigator: React.FC<CovidRegistrationNavigatorProps> = ({
  match,
  isLoggedIn,
  history,
  isCovid = false,
  isSidepOnly = false,
  skipSlot = false,
  automaticCheckin = false
}) => {
  const cleanUrl = match.url.replace(/\/$/, '');

  return (
    <>
      <IonRouterOutlet animated={true}>
        <Route
          path={`${cleanUrl}/patient`}
          render={(props) => (
            <SetPatient
              {...props}
              step={0}
              stepperComponent={<CovidRegistrationStepper step={0} />}
              nextStepRouterLink={`${cleanUrl}/resultat-covid`}
            />
          )}
        />
        <Route
          path={`${cleanUrl}/resultat-covid`}
          render={(props) => (
            <UploadPrescription
              {...props}
              step={1}
              stepperComponent={<CovidRegistrationStepper step={1} />}
              nextStepRouterLink={
                isLoggedIn
                  ? `${cleanUrl}/recapitulatif`
                  : `${cleanUrl}/connexion`
              }
              isCovid={true}
              isUploadMandatory={true}
              titleLabel={
                'Ajoutez votre compte rendu de résultat de dépistage COVID-19'
              }
              subtitleLabel={
                'Ajoutez une photo ou un fichier PDF du compte rendu de résultat. Assurez-vous de la lisibilité du document'
              }
            />
          )}
          exact
        />
        <Route
          path={`${cleanUrl}/connexion`}
          render={(props) => (
            <RegisterStep
              {...props}
              step={2}
              stepperComponent={<CovidRegistrationStepper step={2} />}
              nextStepRouterLink={`${cleanUrl}/recapitulatif`}
            />
          )}
        />
        <Route
          path={`${cleanUrl}/recapitulatif`}
          render={(props) => (
            <Summary
              {...props}
              step={3}
              stepperComponent={<CovidRegistrationStepper step={3} />}
              nextStepRouterLink={`${cleanUrl}/merci`}
              automaticCheckin={automaticCheckin}
            />
          )}
          exact
        />
        <Route
          path={`${cleanUrl}/merci`}
          render={(props) => (
            <ThankYou
              {...props}
              step={4}
              stepperComponent={<CovidRegistrationStepper step={4} />}
              showRatingModal={false}
              bodyText={
                'Votre enregistrement a bien été réalisé. Votre test va maintenant être relu par nos équipes médicales. Vous recevrez sous peu, par email une confirmation de votre accès à notre évènement. Pensez bien à présenter ces éléments pour accéder à l’AccorHotels Arena.<br/><br/>À bientôt'
              }
            />
          )}
          exact
        />
        <Redirect
          exact
          from={COVID_REGISTRATION_ROUTE}
          to={`${COVID_REGISTRATION_ROUTE}/patient`}
        />
      </IonRouterOutlet>
      <TabBar history={history} className="ion-custom-hide-md-down" />
    </>
  );
};

export interface AppointmentStepProps<T = {}> extends RouteComponentProps<T> {
  step: number;
  nextStepRouterLink?: string;
}

export default connect(mapStateToProps, null)(CovidRegistrationNavigator);
